module.exports = __webpack_public_path__ + "img/download.eb2c18f7.svg";